import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import Sidebar from '../Sidebar';
import { Session } from "../utils/session";


const authHeaders = () => {
  const token = Session.getToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
};
export default function MembersEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();

  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [roles, setRoles] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);

const [form, setForm] = useState({
  UserId: id,
  UserName: '',
  FirstName: '',
  LastName: '',
  Email: '',
  PhoneNo: '',
  UserRoleId: '',
  IsActive: true,
  AvatarBase64: '',
  workspaceIds: []
});


  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar(s => !s);
    } else {
      setHideDesktop(s => !s);
    }
  };
  
const handleWorkspaceChange = (id) => {
  setForm(prev => ({
    ...prev,
    workspaceIds: prev.workspaceIds.includes(id)
      ? prev.workspaceIds.filter(x => x !== id)
      : [...prev.workspaceIds, id]
  }));
};

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) setShowMobileSidebar(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Sidebar logic - useEffect for direct DOM manipulation
  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile'); else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop'); else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');
    if (content) {
      if (hideDesktop) content.classList.add('full-width'); else content.classList.remove('full-width');
    }
  }, [showMobileSidebar, hideDesktop]);

  useEffect(() => {
    if (state?.user) {
      setForm(f => ({
        ...f,
        ...{
          UserId: state.user.UserId,
          UserName: state.user.UserName || '',
          FirstName: state.user.FirstName || '',
          LastName: state.user.LastName || '',
          Email: state.user.Email || '',
          PhoneNo: state.user.PhoneNo || '',
          UserRoleIds: state.user.userRoleIds
  ? state.user.userRoleIds.split(',').map(Number)
  : [],
          IsActive: state.user.IsActive ?? true,
          AvatarBase64: state.user.Avatar || '',
           workspaceIds: state.user.WorkspaceIDs
        ? state.user.WorkspaceIDs.split(',').map(Number)
        : []
        }
      }));
    }
  }, [state]);

 useEffect(() => {
  const loadLookups = async () => {
    try {
      setLoading(true);

      const [rolesRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/UserRole/roles`, { headers: authHeaders() })
      ]);

      if (!rolesRes.ok) {
        console.error('Roles fetch failed', rolesRes.status, await rolesRes.text());
        throw new Error(`Roles request failed with status ${rolesRes.status}`);
      }
      const rolesData = await rolesRes.json();
    
      setRoles(rolesData || []);
    } catch (err) {
      console.error('Failed to load lookups:', err);
    } finally {
      setLoading(false);
    }
  };

  loadLookups();
}, []);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setForm({ ...form, AvatarBase64: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    UserId: form.UserId,
    UserName: form.UserName,
    FirstName: form.FirstName,
    LastName: form.LastName,
    Email: form.Email,
    PhoneNo: form.PhoneNo,
    UserRoleIds: form.UserRoleIds.join(','),
    IsActive: form.IsActive,
    AvatarBase64: form.AvatarBase64,
    WorkspaceIDs: form.workspaceIds.join(',') 
  };
  try {
    const res = await fetch(`${API_BASE_URL}/api/Members/update`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      alert('Member updated successfully');
      navigate('/Members');
    } else {
      const errorText = await res.text();
      alert('Update failed: ' + errorText);
    }
  } catch (err) {
    alert('Update failed: ' + err.message);
  }
};
 useEffect(() => {
const loadWorkspaces = async () => {
    try {

      const res = await fetch(
        `${API_BASE_URL}/api/Workspace/Workspaces_List`,
        { headers: authHeaders() }
      );

      if (!res.ok) throw new Error("Workspace API failed");
      const data = await res.json();
      setWorkspaces(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Workspace load error:", err);
    }
  };
  loadWorkspaces();
  }, []);
  if (loading) return <div className="p-3">Loading...</div>;

  return (
    <div>
      {/* Overlay for mobile sidebar - always rendered, visibility controlled by useEffect */}
      <div id="sidebar-overlay" className="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      <div id="sidebar">
        <Sidebar />
      </div>
      <div id="content">
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-3">
            <button
              type="button"
              className="btn btn-toggle"
              onClick={toggleSidebar}
            >
              <i className="fas fa-bars" />
            </button>
            <a href="/Members" className="text-muted text-decoration-none small">
              <i className="fas fa-chevron-left" /> Back
            </a>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-4 page-header">
          <h2>Edit Member</h2>
        </div>
        <div className="main-card">
          <form onSubmit={handleSubmit} className="row g-3 mt-2">
            <div className="col-md-6">
              <label className="form-label">Username</label>
              <input className="form-control" name="UserName" value={form.UserName} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">First Name</label>
              <input className="form-control" name="FirstName" value={form.FirstName} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Last Name</label>
              <input className="form-control" name="LastName" value={form.LastName} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input className="form-control" name="Email" value={form.Email} onChange={handleChange} />
            </div>
            <div className="col-md-6">
                <label className="form-label">Roles</label>

                <div className="border rounded p-2" style={{ maxHeight: "180px", overflowY: "auto" }}>
                  {roles.map((r) => {
              const roleId = Number(
              r.id ??
              r.userRolesId ??
              r.UserRolesId
            );
            console.log(roleId, r);
                        return (
                            <div key={roleId} className="form-check mb-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`role_${roleId}`}
                                    checked={form.UserRoleIds?.includes(roleId)}
                                    onChange={() =>
                                        setForm(prev => ({
                                            ...prev,
                                            UserRoleIds: prev.UserRoleIds.includes(roleId)
                                                ? prev.UserRoleIds.filter(x => x !== roleId)
                                                : [...prev.UserRoleIds, roleId]
                                        }))
                                    }
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor={`role_${roleId}`}
                                >
                                    {r.name}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input className="form-control" name="PhoneNo" value={form.PhoneNo} onChange={handleChange} />
            </div>
                         <div className="col-md-6">
  <label className="form-label">Select Teams</label>

  <div className="d-flex flex-wrap gap-3">
    {workspaces.map((w) => {
      const id = Number(w.workspaceID || w.WorkspaceID);

      return (
        <div key={id} className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id={`team_${id}`}
            checked={form.workspaceIds.includes(id)}
            onChange={() => handleWorkspaceChange(id)}
          />

          <label
            className="form-check-label"
            htmlFor={`team_${id}`}
          >
            {w.workspaceName || w.WorkspaceName}
          </label>
        </div>
      );
    })}
  </div>
</div>
           
            <div className="col-md-6">
              <label className="form-label">Profile Image</label>
              <input type="file" className="form-control" accept="image/*" onChange={handleImage} />
            </div>
            {form.AvatarBase64 && (
              <div className="col-md-6">
                <label className="form-label">Current Image</label>
                <div>
                  <img
                    src={form.AvatarBase64}
                    alt="Avatar"
                    style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '1px solid #ddd' }}
                  />
                </div>
              </div>
            )}
             <div className="col-md-6 d-flex align-items-end">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" name="IsActive" checked={form.IsActive} onChange={handleChange} id="IsActive" />
                <label className="form-check-label" htmlFor="IsActive">IsActive</label>
              </div>
            </div>
            <div className="col-12 mt-3">
              <button className="btn btn-success">Update</button>
              <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate('/Members')}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
